import pic1 from "../Assets/Projects Images/project1.jpg";
import pic2 from "../Assets/Projects Images/project2.jpg";
import pic3 from "../Assets/Projects Images/project3.jpg";

const projects = [
  {
    id: 1,
    project_name: "CUSTOMIZED 3 DIMENSIONAL PRINTER",
    imgURL: pic2,
    project_content:
      "It is a customized printer made from scratch in our workshop. It develops a Layered 3D model, replicating a CAD file, by using PLA as a filament by utilizing some open-source resources like solid works.",
    githubURL: "https://www.linkedin.com/in/prathisupadhyay/",
    youtubeURl: "https://www.linkedin.com/in/prathisupadhyay/",
  },
  {
    id: 2,
    project_name: "AUTONOMOUS PATH FINDER ROBOT",
    imgURL: pic3,
    project_content:"It is a Fully-Autonomous Obstacle avoider and Pathfinder robot with an Omni-Wheel drive and Ultrasonic Sensor. It can traverse in an established path with the ability to move its wheels at a 45-degree inclination.",
    githubURL: "https://www.linkedin.com/in/prathisupadhyay/",
    youtubeURl: "https://www.linkedin.com/in/prathisupadhyay/",
  },

  {
    id: 3,
    project_name: "AUTONOMOUS QUADRUPLED ROBOT",
    imgURL: pic1,
    project_content:"It is 3D Printed Autonomous four-legged robot with Servo Motors for actuation. It was simulated on MAT LAB before assembling. Its main purpose is to navigate the path and it is small enough to be used indoors.",
    githubURL: "https://www.linkedin.com/in/prathisupadhyay/",
    youtubeURl: "https://www.linkedin.com/in/prathisupadhyay/",
  },
];
export default projects;
